module.exports = __webpack_public_path__ + "img/hotellet.f5a8652b.png";